// extracted by mini-css-extract-plugin
export default {"container":"Robot_container__snvG1","panel":"Robot_panel__1Lo1l","wrapper":"Robot_wrapper__EcpDv","info":"Robot_info__Sa355","unit":"Robot_unit__AEsOJ"};